import { GymTypes } from 'fitbeat.models';
import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';
export class EquipmentFilter implements IExerciseSelectionFilter {
  public description: string = 'Return only exercises that match the equipment';
  public name: string = 'EquipmentFilter';
  public filter(
    inputExercises: Exercise[],
    exerciseSelection: ExerciseSelection,
    userWorkoutSettings: WorkoutSettings,
    selectedZoneExercisesSoFar: Exercise[],
    workoutStartDate: Date,
    gymType: GymTypes,
   ): Exercise[] {
    const equipmentFromSettings = userWorkoutSettings.equipment || [];
    const equipmentListToBeUpdated = [...equipmentFromSettings];
    return inputExercises.filter((exercise) => {
      if (exercise.equipment.length === 0) {
        return false;
      }

      return exercise.equipment.every((e) => equipmentListToBeUpdated.indexOf(e) !== -1);
    });
  }
}
